import { STATUS } from "@/constant/statusConstants";
import * as Yup from "yup";

const PlayerTypeSchema = () =>
  Yup.object().shape({
    sport_id: Yup.number().label("Sport").required(),
    code: Yup.string().label("ID").required(),
    name: Yup.string().label("Player Type").required(),
    status: Yup.string()
      .label("Status")
      .required()
      .oneOf(Object.values(STATUS)),
  });

export default PlayerTypeSchema;
